import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Question from './Question'

const useStyles = makeStyles(sectionStyles)

export default function Section({section, context}) {

  const classes = useStyles()

  const {translate, quizSections: sections = []} = context

  const sectionIndex = sections.findIndex(s => s.id == section.id)
  const {title} = sectionIndex >= 0 && sections[sectionIndex] || {}

  const sectionTitle = `${sectionIndex + 1}. ${title || translate('section')}`

  return (
    <Box className={classes.section}>
      <Box className={classes.sectionTitle}>
        {sectionTitle}
      </Box>
      <Box className={classes.questions}>
        {section.questions.map(question => <Question key={question.id} {...{question, context}} />)}
      </Box>
    </Box>
  )
}

function sectionStyles(theme) {

  return {
    sectionTitle: {
      color: '#68728b',
      fontWeight: 'bold',
      fontSize: '13pt'
    },
    questions: {
      display: 'flex',
      flexDirection: 'column',
      padding: 10
    }
  }
}
